import { render, staticRenderFns } from "./ITrash.vue?vue&type=template&id=c00b37e8&"
import script from "./ITrash.vue?vue&type=script&lang=ts&"
export * from "./ITrash.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports